import { Component, OnInit, ViewChild } from "@angular/core";
import { IonContent } from "@ionic/angular";
import { EventsService } from "src/app/services/event/event.service";

@Component({
  selector: "app-tab-promotions",
  templateUrl: "tab-promotions.page.html",
  styleUrls: ["tab-promotions.page.scss"],
})
export class TabPromotionsPage implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  constructor(
    private events: EventsService
  ) { }

  ngOnInit(): void {
    this.events.subscribe('event:scroll:promotions', () => {
      this.scrollToTop();
    });
  }

  private scrollToTop(): void {
    this.content.scrollToTop(10);
  }

  ionViewWillEnter() {
    this.events.publish('event:autoScrollselectedkeyword');
  }
}
